import { builder } from "Classes/global";

export class SceneExportService {
    public static saveCurrentScene(sceneName?: string, exportFile = false): any {
        const room = builder?.room as any;

        if (!room) {
            console.error("No room available");
            return;
        }

        const config = room.buildExportConfiguration(sceneName);

        if (exportFile) {
            SceneExportService.downloadJSON(config, config.name);
            return;
        }

        return config;
    }

    private static downloadJSON(data: unknown, filename: string): void {
        const blob = new Blob([JSON.stringify(data, null, 2)], {
            type: "application/json",
        });

        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}.json`;

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        URL.revokeObjectURL(url);
    }
}
